import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import AppRoutes from './app-routes';
import { UserSessionService } from './services/user-session.service';
@Injectable({
  providedIn: 'root',
})
export class AutherizedGuard implements CanActivate {
  autherized: boolean = false;
  constructor(private userSession: UserSessionService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    switch (state.url) {
      case `/${AppRoutes.Downloads}`:
        this.autherized = this.userSession.excelDownLoadEnabled;
        break;
    }
    return this.autherized;
  }
}
